import gql from 'graphql-tag';

export const GET_LENDER_PERFORMANCE_RATIO_CARDS = gql`
  query LenderPerformanceRatioCards($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: ratioCards(input: $input) {
        success
        error
        entity {
          avgResponseTime {
            current
            formatted
          }
          fundRate {
            current
          }
          fundedVolume {
            current
          }
          lookToBook {
            current
          }
          responseRate {
            current
          }
        }
      }
    }
  }
`;
